let sentinel: WakeLockSentinel | null = null;
let acquiring = false;
let warned = false;

/** An unattended player window otherwise lets the display sleep mid-schedule. */
export function installWakeLock(): void {
  if (!('wakeLock' in navigator)) return;
  document.addEventListener('visibilitychange', () => void acquire());
  void acquire();
}

// The lock is dropped whenever the document hides, so re-acquire on every return.
async function acquire(): Promise<void> {
  if (sentinel || acquiring || document.visibilityState !== 'visible') return;
  acquiring = true;
  try {
    const lock = await navigator.wakeLock.request('screen');
    // A visibility flap during the request can release it before we ever saw it.
    lock.addEventListener('release', () => {
      if (sentinel === lock) sentinel = null;
    });
    if (lock.released || document.visibilityState !== 'visible') return;
    sentinel = lock;
  } catch (err) {
    if (!warned) {
      warned = true;
      console.warn('[WakeLock] screen wake lock unavailable', err);
    }
  } finally {
    acquiring = false;
  }
}
